import { GlobalFooter } from "@/patterns/global-footer/src/index";
import StickyContainer from "@/patterns/sticky-container/sticky-container";

import {
    BlogsSection,
    CTASection,
    DevOpsSection,
    LoggedInHeroSection,
    IntegrationSection,
    ScalingSection,
    TabsSection,
    WorkflowSection
} from "..";
import { ParentScrollTracking } from "../../../../../../utils/scroll-tracking";
import JiraSoftwareNavV2 from "../../../sections/nav-bar/software-jira-navbar";

export const LoggedInJiraProductTourOverview = () => {
    return (
        <div>
            <StickyContainer>
                <JiraSoftwareNavV2 />
            </StickyContainer>
            <ParentScrollTracking scrollTrackingEnabled={true} pageId="jsw">
                <LoggedInHeroSection />
                <TabsSection />
                <WorkflowSection />
                <IntegrationSection />
                <DevOpsSection />
                <BlogsSection />
                <ScalingSection />
                <CTASection />
                <GlobalFooter />
            </ParentScrollTracking>
        </div>
    );
};
